import React from "react";

const publicUrl = process.env.PUBLIC_URL;
const logoIcon = `${publicUrl}/assets/images/logo-icon.png`;
const boxBackgroundImg = `${publicUrl}/assets/images/proposal/box-background-img.png`;

interface ProposalPropertyPhotosProps {
    index: number;
    propertyData: any;
}

export default function ProposalPropertyPhotos({ index,
    propertyData }: ProposalPropertyPhotosProps) {
    return (
        <>
            {propertyData?.excludePhotoGallery === false && propertyData?.propertyPhotos?.length ? (
                <table className="table-outer-area page-break"
                    style={{
                        // backgroundImage: `url(${require("../../../assets/images/proposal/box-background-img.png")})`,
                        backgroundImage: `url(${boxBackgroundImg})`,
                        // backgroundImage: `url(${backgroundBgWithShadow})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "bottom",
                        backgroundSize: "cover",
                        marginTop: "15px",
                        minHeight: "794px",
                    }}
                    width="100%"
                    cellPadding="10"
                    cellSpacing="0"
                >
                    <tbody>
                        <tr>
                            <td align="right">
                                <img
                                    width={110}
                                    src={logoIcon}
                                    alt="property image"
                                />
                            </td>
                        </tr>

                        <tr>
                            <td width="100%" className="pl-40"
                                style={{
                                    color: "#021D77",
                                    marginTop: "-57px",
                                    display: "block",
                                }}
                            >
                                <span style={{ fontSize: "18px" }}>
                                    O P T I O N {index + 1}
                                </span>
                                <br />
                                <div style={{ display: 'flex', }}>
                                    <strong
                                        style={{ fontSize: "25px", fontWeight: 700, maxWidth: '80%', flexShrink: 0 }}
                                    >
                                        {propertyData?.propertyName?.toUpperCase()}
                                    </strong>
                                    <div style={{ height: '4px', width: '100%', backgroundColor: '#C39864', marginTop: '18px', marginLeft: '10px' }}></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table
                                    cellPadding="10"
                                    cellSpacing="0"
                                    width="100%"
                                >
                                    <tbody>

                                        <tr>
                                            <td align="center">
                                                <table
                                                    cellPadding="4"
                                                    cellSpacing="0"
                                                    width="100%"
                                                    style={{ borderCollapse: "separate" }}
                                                >
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <span
                                                                    style={{
                                                                        fontSize: "22px",
                                                                        color: "#8FA9D4",
                                                                        fontWeight: 700,
                                                                    }}
                                                                >
                                                                    <u> PROPERTY PHOTOS</u>
                                                                </span>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td>
                                                                <div style={{ display: 'grid', gap: '16px', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
                                                                    {propertyData?.propertyPhotos?.map(
                                                                        (photo: {
                                                                            propertyImageName: string;
                                                                            propertyImage: string;
                                                                        }) => (
                                                                            <div>
                                                                                <img
                                                                                    src={photo.propertyImage}
                                                                                    style={{ width: "100%" }}
                                                                                    alt={
                                                                                        photo?.propertyImageName
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td height="160"></td>
                        </tr>
                    </tbody>
                </table>
            ) : null}
        </>
    );
}
